import { rootMeanSquareDifference } from "./index243.js";
function getCorridorCost(state, props) {
  if (props.skipCores) {
    return 0;
  }
  const corridorDists = state.corridorLengths;
  const targetDists = new Array(corridorDists.length).fill(props.maxCorridorDists.middle);
  if (corridorDists.length === 1) {
    targetDists[0] = Math.min(props.maxCorridorDists.start, props.maxCorridorDists.end);
  } else {
    targetDists[0] = props.maxCorridorDists.start;
    targetDists[targetDists.length - 1] = props.maxCorridorDists.end;
  }
  const targetDistsAdjusted = targetDists.map((v) => 0.5 * v);
  const corridorDistsAdjusted = corridorDists.map((v) => 0.5 * v);
  if (props.maxCorridorDists.start !== props.maxCorridorDists.middle) {
    targetDistsAdjusted[0] *= 2;
    corridorDistsAdjusted[0] *= 2;
  }
  if (props.maxCorridorDists.end !== props.maxCorridorDists.middle) {
    targetDistsAdjusted[targetDistsAdjusted.length - 1] *= 2;
    corridorDistsAdjusted[corridorDistsAdjusted.length - 1] *= 2;
  }
  let corridorCost = rootMeanSquareDifference(corridorDistsAdjusted, targetDistsAdjusted);
  for (let i = 0; i < corridorDists.length; i++) {
    if (corridorDists[i] > targetDists[i]) {
      corridorCost += 1e6;
    }
  }
  return corridorCost;
}
export {
  getCorridorCost
};
//# sourceMappingURL=index201.js.map
